<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 221.492"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="39.999"
            cy="77.948"
            r="9.965"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondLeft}"
            @click="select('secondLeft')"
            d="M24.678 51.1c1.096,2.346 2.519,4.683 4.314,6.854 3.692,-1.877 7.263,-3.224 10.715,-4.042 -2.751,-9.94 -3.017,-22.271 -0.798,-36.992 -4.287,-0.849 -8.465,-2.147 -12.534,-3.893 -6.253,5.406 -9.768,13.088 -8.606,21.62 0.677,4.964 3.457,9.072 6.909,16.453z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.first}"
            @click="select('first')"
            d="M38.909 16.92c4.635,0.919 9.399,1.314 14.29,1.185 6.336,-0.168 12.886,-1.215 19.651,-3.141 -4.951,-6.045 -13.356,-10.051 -24.069,-9.961 -8.761,0.074 -16.717,3.107 -22.406,8.024 4.069,1.746 8.247,3.044 12.534,3.893z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.secondRight}"
            @click="select('secondRight')"
            d="M53.199 18.105c2.43,13.039 1.393,24.698 -3.111,34.976 6.168,0.548 11.892,3.063 17.17,7.543 1.022,-1.238 1.956,-2.579 2.806,-3.993 5.038,-8.371 7.165,-19.266 7.688,-26.272 0.423,-5.676 -1.352,-11.06 -4.902,-15.395 -6.765,1.926 -13.315,2.973 -19.651,3.141z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M50.088 53.081c4.504,-10.278 5.541,-21.937 3.111,-34.976 -4.891,0.129 -9.655,-0.266 -14.29,-1.185 -2.219,14.721 -1.953,27.052 0.798,36.992 3.59,-0.85 7.05,-1.127 10.381,-0.831z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M39.975 53.804c-3.452,0.818 -7.023,2.165 -10.715,4.042 4.001,4.838 9.854,8.847 18.084,10.279 8.985,1.562 15.514,-1.953 20.182,-7.609 -8.106,-6.88 -17.292,-9.141 -27.551,-6.712z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M70.064 56.631c-4.856,40.305 -1.223,91.363 -11.538,141.535 -11.966,25.17 -16.851,-30.363 -25.377,-83.296 -5.853,-36.33 -4.556,-47.32 -4.157,-56.916m19.789 -52.951c-18.393,0.154 -33.231,13.35 -31.012,29.644 0.677,4.964 3.457,9.072 6.909,16.453 3.541,7.573 10.475,15.059 22.398,17.133 22.608,3.932 29.663,-24.283 30.676,-37.874 1.013,-13.591 -10.577,-25.51 -28.971,-25.356z"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="47.945"
            cy="207.777"
            r="9.965"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
